module.exports = __webpack_public_path__ + "assets/img/BodyLux-w540.669d3295.jpg";